//jqueryFree
/**
 * pokud se nastavi na `window.reloadIfBrowserBack = true` tak se provede kontrola
 * zda se neprichazi na stranku pres tlacitko zpet, pokud ano, provede se reload
 */
export default function () {

    function reload(from) {
        console.info("history.back action is not allowed (" + from + ")");
        window.location.reload();
    }

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            //console.log('This page was restored from the bfcache.', window.reloadIfBrowserBack);
            if (window.hasOwnProperty("reloadIfBrowserBack") && typeof window.reloadIfBrowserBack === "boolean" && window.reloadIfBrowserBack) {
                reload(1);
            }
        } else {
            //console.log('This page was loaded normally.');
        }
    });

    if (window.hasOwnProperty("reloadIfBrowserBack") && typeof window.reloadIfBrowserBack === "boolean" && window.reloadIfBrowserBack) {
        const performanceEntries = performance.getEntriesByType('navigation');

        if (performanceEntries.length > 0) {
            //https://w3c.github.io/navigation-timing/#sec-performance-navigation-types
            if (performanceEntries[0].type === 'back_forward') {
                reload(2);
            }
        } else {
            console.warn('PerformanceNavigationTiming API není dostupné.');
            // Pro zpětnou kompatibilitu s prohlížeči, které nepodporují PerformanceNavigationTiming API:
            if (performance.navigation.type === 2) {
                reload(3);
            }
        }
    }
}
